import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.WHATSAPP_HUB,
  permissions: ['administrator', 'agent'],
};

const whatsappHubRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp-hub'),
      name: 'whatsapp_hub',
      component: () => import('./WhatsAppHub.vue'),
      meta,
    },
  ],
};

export default whatsappHubRoutes;
